/**
 * Legacy wrapper: the old spotlight tour was disabled here (dead code).
 * The real walkthrough is CoachMark + {@link createProductTourSteps} in WorkspaceShell.
 *
 * This component only forwards `children` and registers `window.restartAppTour` so that
 * older call sites (e.g. UserProfile OnboardingTab) still start the CoachMark tour.
 */

import React, { useEffect } from 'react';

import { FORCE_PRODUCT_TOUR_EVENT } from '../../lib/productTourSteps';

interface TourProviderProps {
  children: React.ReactNode;
  /** Kept for API compatibility with DashboardContainer (unused). */
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const TourProvider: React.FC<TourProviderProps> = ({ children }) => {
  useEffect(() => {
    window.restartAppTour = async () => {
      window.dispatchEvent(new CustomEvent(FORCE_PRODUCT_TOUR_EVENT));
    };
    return () => {
      delete window.restartAppTour;
    };
  }, []);

  return <>{children}</>;
};

declare global {
  interface Window {
    restartAppTour?: () => Promise<void>;
  }
}

export default React.memo(TourProvider);
